import type { CaseStatus } from "../types/domain";

export const statusLabels: Record<CaseStatus, string> = {
  draft: "Borrador",
  submitted: "Presentado",
  initial_review: "En validación",
  correction_required: "Corrección requerida",
  correction_submitted: "Corrección enviada",
  admitted: "Admitido",
  assigned: "Derivado",
  in_progress: "En gestión",
  resolved: "Resuelto",
  rejected: "Rechazado",
  archived: "Archivado",
  cancelled: "Cancelado",
};

export function formatDate(value: string | null, withTime = false): string {
  if (!value) return "Sin fecha";
  return new Intl.DateTimeFormat("es-PY", {
    dateStyle: "medium",
    ...(withTime ? { timeStyle: "short" as const } : {}),
    timeZone: "America/Asuncion",
  }).format(new Date(value));
}

export function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export function formatGuarani(value: number): string {
  return new Intl.NumberFormat("es-PY", {
    style: "currency",
    currency: "PYG",
    maximumFractionDigits: 0,
  }).format(value);
}

export function maskDocument(value: string): string {
  const digits = value.replace(/\D/g, "");
  if (digits.length <= 3) return "***";
  return `${"*".repeat(Math.max(3, digits.length - 3))}${digits.slice(-3)}`;
}
